import { jsxs as e, jsx as _ } from "react/jsx-runtime";
import { Icon as r } from "@blueprintjs/core";
import g from "classnames";
import "./main.scss";
const b = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
}, k = {
  small: 40,
  medium: 80,
  large: 120
}, d = {
  ERROR: "error",
  WARNING: "warning",
  SUCCESS: "success",
  DEFAULT: ""
}, m = ({
  size: s,
  icon: o = void 0,
  iconSize: n = void 0,
  iconStatus: i = d.DEFAULT,
  primaryText: a = void 0,
  secondaryText: c = void 0,
  className: l = void 0
}) => /* @__PURE__ */ e(
  "div",
  {
    className: g(
      "sds_messaging-block",
      { [`sds_messaging-block--${s}`]: s },
      l
    ),
    children: [
      o && /* @__PURE__ */ _(
        r,
        {
          className: g("sds_messaging-block__icon", {
            [`sds_messaging-block__icon--${i}`]: i,
            [`sds_messaging-block__icon--${s}`]: s
          }),
          size: n ?? k[s],
          icon: typeof o == "string" ? o : /* @__PURE__ */ _(
            "div",
            {
              className: g("sds_messaging-block__icon", {
                [`sds_messaging-block__icon--${i}`]: i,
                [`sds_messaging-block__icon--${s}`]: s
              }),
              children: o
            }
          )
        }
      ),
      a && /* @__PURE__ */ _(
        "div",
        {
          className: g("sds_messaging-block__heading", {
            [`sds_messaging-block__heading--${s}`]: s
          }),
          children: a
        }
      ),
      c && /* @__PURE__ */ _(
        "div",
        {
          className: g("sds_messaging-block__subheading", {
            [`sds_messaging-block__subheading--${s}`]: s
          }),
          children: c
        }
      )
    ]
  }
);
m.Status = d;
m.Sizes = b;
export {
  m as MessagingBlock
};
//# sourceMappingURL=index.js.map
